<div #download>
	<ng-content></ng-content>
</div>

<!-- Download --> 
<div class="grid__row" *ngIf="filename">
	<div class="grid__col--12">
		<p><button class="btn btn--gold float--right" (click)="save()">Save Screenshot</button></p>
	</div>
</div>